import { theme } from '@Guidelines/Theme/theme';
import formatEuros from '@UI/Helpers/formatEuros';
import LimitStatusTag from '@UI/Pages/Administration/AiCostLimits/Shared/LimitStatusTag';
import type AiCostLimitView from '@UI/Store/AiCostLimits/Views/AiCostLimitView';
import { css } from '@emotion/react';
import type * as React from 'react';

const detailsStyle = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 0.75rem;
`;

const textStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.125rem;
`;

const nameStyle = css`
	${theme.typography.cardTitle}
	margin: 0;
	color: ${theme.colors.ink};
`;

const figuresStyle = css`
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.inkSecondary};
`;

type Props = {
	readonly limit: AiCostLimitView;
	readonly subjectName: string;
};

const LimitDetails: React.FC<Props> = ({ limit, subjectName }) => {
	return (
		<div css={detailsStyle}>
			<div css={textStyle}>
				<p css={nameStyle}>{subjectName}</p>
				<span css={figuresStyle}>
					{formatEuros(limit.monthlyAmount)} par mois · Alerte à {limit.alertThresholdPercent} %
				</span>
			</div>
			<LimitStatusTag limit={limit} />
		</div>
	);
};

export default LimitDetails;
